import type { AirportOption } from "@/types/booking"

const cityCache = new Map<string, { city: string; country: string }>()
const PELIKAN_URL = "https://www.pelikan.sk/gf1/pelijee-sk/mobile/autocomplete"

interface PelikanAirportItem {
  airportCode?: string
  cityCode: string
  city: string
  country?: string
}

export function cacheCityCode(
  code: string,
  city: string,
  country: string
) {
  cityCache.set(code, { city, country })
}

export function lookupCityCode(
  code: string
): AirportOption | null {
  const entry = cityCache.get(code)
  if (!entry) return null
  return { code, city: entry.city, country: entry.country }
}

export async function resolveAirportCode(code: string): Promise<AirportOption | null> {
  const cached = lookupCityCode(code)
  if (cached) return cached

  try {
    const response = await fetch(
      `${PELIKAN_URL}?q=${encodeURIComponent(code)}&lang=en`
    )
    const contentType = response.headers.get("content-type") ?? ""
    if (!response.ok || !contentType.includes("application/json")) return null

    const data: unknown = await response.json()
    if (!Array.isArray(data)) return null

    const match = (data as PelikanAirportItem[]).find(
      (item) => item.airportCode === code || item.cityCode === code
    )

    if (!match?.city) return null

    const airport = {
      code,
      city: match.city,
      country: match.country ?? "",
    }

    cacheCityCode(airport.code, airport.city, airport.country)
    return airport
  } catch {
    return null
  }
}
